import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyNewsFilterBody } from "my-news/components";
import { OcRoleFilterGroupedSubtypes } from "oc/components";

type MyNewsItemFormFilterEmployeesProps = {
  open: boolean;
  roleFilters: any; // Replace 'any' with the correct type if available
  handleAddFilter: (item: any) => void; // Replace 'any' with the correct type if available
  handleRemoveFilter: (item: any) => void; // Replace 'any' with the correct type if available
  product?: any; // Replace 'any' with the correct type if available
  role?: any; // Replace 'any' with the correct type if available
  contract?: any; // Replace 'any' with the correct type if available
  isMobile?: boolean;
};

export const MyNewsItemFormFilterEmployees = ({
  open,
  roleFilters,
  handleAddFilter,
  handleRemoveFilter,
  product,
  role,

  isMobile,
}: MyNewsItemFormFilterEmployeesProps) => {
  const theme = useTheme();

  return (
    <MyNewsFilterBody
      open={open}
      type="employees"
      width={isMobile ? "auto" : "665px"}
    >
      <Box
        padding="16px"
        style={{ backgroundColor: theme.palette.gray20.main }}
      >
        <OcRoleFilterGroupedSubtypes
          roleFilters={roleFilters}
          handleAddItem={handleAddFilter}
          handleRemoveItem={handleRemoveFilter}
          product={product}
          role={role}
          queryType="notAdmin"
          isCheckbox
        />
      </Box>
    </MyNewsFilterBody>
  );
};

export default MyNewsItemFormFilterEmployees;
